import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteArticleModal = ({
  articleName = I18n.text('knowledgeArticleEditorUI.deleteModal.defaultArticleName'),
  onConfirm,
  onReject,
  isDeletingArticle
}) => {
  const ModalLoadingButton = useCallback(props => /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, props, {
    loading: isDeletingArticle
  })), [isDeletingArticle]);
  return /*#__PURE__*/_jsx(ConfirmModal, {
    ConfirmButton: ModalLoadingButton,
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeArticleEditorUI.deleteModal.confirmButton"
    }),
    "data-test-id": "delete-article-modal",
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeArticleEditorUI.deleteModal.rejectButton"
    }),
    confirmUse: "danger",
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "knowledgeArticleEditorUI.deleteModal.body",
      options: {
        articleName
      }
    }),
    match: I18n.text('knowledgeArticleEditorUI.deleteModal.delete'),
    matcherLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeArticleEditorUI.deleteModal.matcherLabel"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeArticleEditorUI.deleteModal.title"
    }),
    size: "auto",
    use: "danger",
    onConfirm: onConfirm,
    onReject: onReject
  });
};
export default DeleteArticleModal;